import React from "react";
import { Button, Image, Popover, Rate, Tag, Typography } from "antd";
import { Link } from "react-router-dom";
import { EditOutlined } from "@ant-design/icons";
import { IBettingWebsite } from "../../../types/BettingWebsite";
import { CLOUD_URL } from "../../../lib/env";

const { Text } = Typography;

type Props = {
  websites: IBettingWebsite[];
  page: number;
  pageSize: number;
  id: string;
};

export const BettingWebsiteTop10PopOver: React.FC<Props> = ({
  websites,
  page,
  pageSize,
  id,
}) => {
  const content = (
    <div className="space-y-1 max-w-xs">
      {websites.map((item) => (
        <div key={item.id} className="flex gap-2">
          <Image
            className=" rounded-full"
            src={CLOUD_URL + "/" + item.MainInfo.Image}
            width={30}
            height={30}
          />
          <Text>{item.MainInfo.Title.En}</Text>
        </div>
      ))}
    </div>
  );

  return (
    <Popover
      key={JSON.stringify(websites)}
      title={
        <div className="flex flex-row w-full justify-between border-b pb-0.5">
          <span>Betting Websites</span>
          <Link
            to={`/top10-articles/edit-top10-websites/${id}?page=${
              page + 1
            }&pageSize=${pageSize}`}
          >
            <Button size="small" type="link" icon={<EditOutlined />} />
          </Link>
        </div>
      }
      content={content}
      trigger="hover"
      placement="right"
    >
      <Tag color="blue" className="cursor-pointer p-2">
        <div className="flex flex-col gap-1">
          <span>Top 10 Betting Websites</span>
        </div>
      </Tag>
    </Popover>
  );
};
